import { AppAction } from './enum';
import { Overlay } from '@vfde-brix/ws10/overlay';
import { TokenState, Views } from '../../enum';

export const setLoading = (isLoading = true) => ({
    type: AppAction.SET_LOADING as const,
    isLoading,
});

export const setActiveView = (activeView: Views) => ({
    type: AppAction.SET_ACTIVE_VIEW as const,
    activeView,
});

export const initOverlay = (overlay: Overlay | null) => ({
    type: AppAction.INIT_OVERLAY as const,
    overlay,
});

export const toggleOverlay = (shouldOpen = true) => ({
    type: AppAction.TOGGLE_OVERLAY as const,
    shouldOpen,
});

export const setOverlayLoaded = (isLoaded: boolean) => ({
    type: AppAction.SET_OVERLAY_LOADED as const,
    isLoaded,
});

export const initApp = (overlay: Overlay | null) => ({
    type: AppAction.INIT_APP as const,
    overlay,
});

export const setTokenState = (ffTokenState: TokenState) => ({
    type: AppAction.SET_TOKEN_STATE as const,
    ffTokenState,
});

export type Actions = ReturnType<typeof setLoading>
    | ReturnType<typeof setActiveView>
    | ReturnType<typeof setOverlayLoaded>
    | ReturnType<typeof toggleOverlay>
    | ReturnType<typeof initApp>
    | ReturnType<typeof setTokenState>;
